import { gql, useQuery } from '@apollo/client';

import type {
  GetDealMonthRemittances,
  GetDealMonthRemittancesVariables,
} from './__generated__/getDealMonthRemittances_gql';
/**
 * Fetches the deal-month remittances snapshot (wire details + confirmation flags + optimistic-lock version)
 * for a specific deal and payment month. Used by the remittance sidecar to drive wire-confirmation UX.
 */
export const GET_DEAL_MONTH_REMITTANCES = gql`
  query GetDealMonthRemittances($input: GetDealMonthRemittancesInput!) {
    getDealMonthRemittances(input: $input) {
      item {
        payment_month
        version
        buyer_wire_details {
          account_name
          account_number
          bank_name
          routing_number
        }
        seller_wire_details {
          account_name
          account_number
          bank_name
          routing_number
        }
        buyer_remittances_received
        seller_remittances_sent
      }
    }
  }
`;

export function useGetDealMonthRemittances(
  dealId: string | undefined,
  paymentMonth: string | undefined,
) {
  const skip = !dealId?.trim() || !paymentMonth?.trim();
  const { data, loading, error, refetch } = useQuery<
    GetDealMonthRemittances,
    GetDealMonthRemittancesVariables
  >(GET_DEAL_MONTH_REMITTANCES, {
    variables: { input: { deal_id: dealId ?? '', payment_month: paymentMonth ?? '' } },
    skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    item: data?.getDealMonthRemittances?.item ?? null,
    loading,
    error,
    refetch,
  };
}
